import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Zap, AlertTriangle } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen w-full flex flex-col bg-gradient-to-b from-white to-gray-50">
      <div className="flex-grow flex items-center justify-center p-4">
        <div className="w-full max-w-4xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className="bg-blue-50 text-blue-600 px-4 py-2 rounded-full text-sm font-medium animate-float">
                Powered by AI
              </div>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-8 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              About Trademarking.ai
            </h1>
          </div>

          {/* Main Content Card */}
          <div className="bg-white rounded-3xl shadow-[0_10px_40px_-15px_rgba(0,0,0,0.2)] p-6 md:p-12 mb-12">
            <div className="space-y-8">
              <div className="bg-blue-50 p-8 rounded-[16px]">
                <h2 className="text-2xl font-semibold mb-4 text-blue-700">Founding Story</h2>
                <p className="text-lg text-blue-900">
                  Trademarking.ai was born from startup experience. A fast-growing startup with momentum and investor interest 
                  suddenly received a cease and desist letter over the company and product brand name. The impact was immediate - the financing round collapsed 
                  and investors backed away, and ultimately had to pivot to a new name. That meant new packaging, website, and wasted ad spend. It was the hard way how critical early trademark verification is.
                </p>
              </div>

              <div className="p-8 rounded-[16px] border-2 border-gray-100">
                <h2 className="text-2xl font-semibold mb-4 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Mission</h2>
                <p className="text-lg text-gray-600">
                  Trademarking.AI is here to protect founders and venture studios from preventable IP conflicts, and to capture value early on. The platform makes trademark 
                  verification accessible, fast, and affordable at the earliest stages of company building - when it matters most.
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-6">
                <div className="p-6 rounded-[16px] bg-gray-50 hover:bg-gray-100 transition-all duration-300 text-center">
                  <div className="flex justify-center mb-4">
                    <Shield className="w-8 h-8 text-blue-600" />
                  </div>
                  <h3 className="font-semibold mb-2">Verify First</h3>
                  <p className="text-gray-600">Verify brand availability before committing resources</p>
                </div>
                <div className="p-6 rounded-[16px] bg-gray-50 hover:bg-gray-100 transition-all duration-300 text-center">
                  <div className="flex justify-center mb-4">
                    <Zap className="w-8 h-8 text-blue-600" />
                  </div>
                  <h3 className="font-semibold mb-2">Act Fast</h3>
                  <p className="text-gray-600">Protect your IP from day one and avoid costly conflicts</p>
                </div>
                <div className="p-6 rounded-[16px] bg-gray-50 hover:bg-gray-100 transition-all duration-300 text-center">
                  <div className="flex justify-center mb-4">
                    <AlertTriangle className="w-8 h-8 text-blue-600" />
                  </div>
                  <h3 className="font-semibold mb-2">Stay Protected</h3>
                  <p className="text-gray-600">Make informed decisions about your IP strategy</p>
                </div>
              </div>

              <div className="bg-yellow-50 p-8 rounded-[16px]">
                <h2 className="text-2xl font-semibold mb-4 text-yellow-800">Trademarking.AI's Commitment</h2>
                <p className="text-lg text-yellow-900">
                  While Trademarking.AI provides rapid insights for early decision-making, consult with a trademark 
                  attorney for comprehensive legal protection. Trademarking.AI's goal is to help you identify potential issues early, saving 
                  time and resources for proper legal consultation.
                </p>
              </div>
            </div>

            <div className="mt-12 text-center">
              <Link 
                to="/" 
                className="inline-flex items-center justify-center px-6 py-3 text-lg font-medium text-blue-600 hover:text-blue-800 transition-colors"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <footer className="bg-white border-t border-gray-100 py-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-8">
            <div className="flex flex-col md:flex-row gap-4 md:gap-8">
              <Link to="/faq" className="text-gray-600 hover:text-gray-900">FAQ</Link>
              <Link to="/about" className="text-gray-600 hover:text-gray-900">About Trademarking.ai</Link>
              <Link to="/terms" className="text-gray-600 hover:text-gray-900">Terms of Service</Link>
            </div>
          </div>
          
          <div className="text-center">
            <p className="text-lg text-gray-600 font-medium mb-4">
              <strong>COMING SOON:</strong> Generative domain and trademark names, optimized for risk and branding power
            </p>
            <div className="text-sm text-gray-500">
              Copyright © 2025 Sharpe Idea Studio
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}